import { get, patch, post } from 'utils/api';

export const getDealerEntitlements = (data) => {
  return get(`/dealer-entitlements`, data);
};

export const getDealerEntitlementById = (id) => {
  return get(`/dealer-entitlements/${id}`);
};

export const getDealerCreditTransactions = (data) => {
  return get(`/dealer-credit-transactions`, data);
};

export const getDealers = (data) => {
  return get(`/dealers`, data);
};

export const getDealerById = (id) => {
  return get(`/dealers/${id}`);
};

export const getDealerBranches = (id) => {
  return get(`/dealers/${id}/branches`);
};

export const updateDealer = (data) => {
  const id = data.id;
  delete data['id'];
  return patch(`/dealers/${id}`, data);
};

export const setEntitlementVerifiedMac = (data) => {
  const id = data.id;
  delete data['id'];
  return patch(`/dealer-entitlements/${id}/verified-mac`, data);
};

export const syncEntitlement = (id) => {
  return post(`/dealer-entitlements/${id}/sync`);
};

export const dealerEntitlement = {
  setEntitlementVerifiedMac,
  syncEntitlement,
  getDealers,
  getDealerById,
  getDealerBranches,
  updateDealer,
  getDealerCreditTransactions,
  getDealerEntitlements,
  getDealerEntitlementById,
};
